import styled, { ThemeProvider } from 'styled-components';
import React from 'react';
import color from 'color';
import forEach from 'lodash/forEach';

const theme = {
  screen: 'sm',
  color: {
    primary: '#6C6FFF', // theme.color.second
    // second:'#6C6FFF',
    secondary: '#999',
    default: '#292929',
    darkest: '#000',
    darker: '#2b2b2b',
    dark: '#373a3c',
    gray: '#55595c',
    grayLight: '#999',
    grayLighter: '#e7e7e7',
    grayLightest: '#f7f7f9',
    purple: '#8955F7',
    warn: '#f00',
    success: '#4caf50',
    second: '#FF504D', // btn-second
    info: '#FF9E0D',
    mask: 'rgba(0,0,0,.5)',
    bar: 'rgba(255,255,255,.2)',
    white: '#fff',
    black: '#000',
  },
  clientColor: {
    primary: '#40A3FF',
    primaryLinear: 'linear-gradient(90deg, #c669ff 0%, #7555f7 100%)',
    secondary: '#c3c3c3',
    third: '#9566F8',
    panelBgColor: '#323841',
    popupBgColor: '#3e454d',
    tabBgColor: '#363D44',
  },
  colorHover: {},
  size: 40,
  zIndex: {
    im: 4000,
    topBar: 3000,
    floatPopupMask: 1000,
    floatPopup: 1100,
    pageFloat: 2200,
    pageFloatHover: 2350,
    pageFloatMask: 2290,
    pageMask: 5000,
    page: 5100,
    pagePopup: 6100,
    pagePopupMask: 6000,
    modalMask: 8000,
    modal: 8001,
    toastMask: 10000,
    toast: 10100,

    broadcast: 90000,
  },
  videoZIndex: {
    bottomPopup: 1050,
    enterAnimation: 1030,
    oathPopup: 1020,
    svgaPlayer: 1010,
    videoGift: 1000,
    playerAction: 900,
    popup_content: 600,
    popup: 530,
    top: 510,
    floatHover: 500,
    giftAnimate: 410,
    invitingList: 305,
    marquee: 301,
    float: 200,
    focusStar: 200,
    fightPk: 120, // 厅战/个播
    activity: 115,
    pkTopic: 114,
    timingPk: 114,
    sofa: 110,
    rest: 105,
    joinLive: 103,
    playerSetting: 104,
    playerSelectDevice: 100,
    blendLayer: 100,
    punishTip: 99,
    playerTime: 12,
    officialLink: 10,
    tequan: 4,
  },
};

forEach(theme.color, (val, key) => {
  theme.colorHover[key] = color(val).darken(0.1).hex();
});

// console.log('theme====>',theme)

type ThemeInterface = typeof theme;

declare module 'styled-components' {
  interface DefaultTheme extends ThemeInterface {}
}

const WithTheme = ({ children }: any) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

const screen = (opts) => {
  return (props) => {
    return opts[props.theme.screen];
  };
};

export { WithTheme };

export default theme;
